module.exports = __webpack_public_path__ + "static/media/braille.2e27f13b.svg";